export default __webpack_public_path__ + "static/media/footer-edit-pen.afe3b343.svg";